import Breadcrumb from "@/components/Breadcrumb";
import Hero2 from "@/components/Hero2";
import OfficeListing from "@/components/OfficeListing";
import ContactHero from "@/components/ContactHero";
import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";

import { offices_helper } from "@/helpers/offices_helper";


export default function ContactUsPage({all_offices}) {

  const image = {
    path: "contact_us.contact_hero.image",
  };

  return (
    <>
      <div style={{marginTop: '120px'}}>
        <SeoHead
            page_name={`Contact Us · EarthStream`}
            canonical_link={`https://www.earthstreamglobal.com/contact-us`}
          />
        <div className={classes.cont}>
          <Breadcrumb label="Contact Us" />
          <Hero2 readMore={false} highlight="contact us" body="Have a question or need assistance? We're here to help! Select a city below to connect with our team of local experts."></Hero2>
        </div>
        <OfficeListing offices={all_offices} />
         <ContactHero dark={true} image={image} title="work for earthstream" 
          subtitle="We believe that unlocking the potential of our workforce through outstanding training, earning potential and reward structures is key to EarthStream's success." 
          description="We offer all our employees a world-class recruitment environment to support their career growth from trainee level to management and beyond. Our industry-leading incentives include everything from luxury lunch clubs and international travel experiences to exciting relocation opportunities across the globe. Find out more about life at EarthStream." 
          buttonLabel="Join Our Team" buttonLink="/join-us" />
      </div>
      
    </>
  );
}

export async function getStaticProps({}) {
  const all_offices = offices_helper.fetch();

  return {
    props: {
      all_offices
    },
  };
}
